/*
 * View for Topics Controls
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "modules/topicsSplit/topics/topicsList/topicsControls/template/topicsControlsTemplate.html",
], function (Marionette, $, _, TopicsControlsTemplate) {
  const TopicsControlsView = {};

  TopicsControlsView.topicsControlsView = Marionette.ItemView.extend({
    template: TopicsControlsTemplate,
    events: {
      "click #changeTopicContext": function () {
        //use event instead of trigger to avoid blocking the propagation of this event
        //if we are opening the change status menu, trigger the event and generate menu listing
        if (!this.ui.topicContextDropdown.hasClass("open")) {
          //since the menu will show up even if we don't want it to, hide it until we are sure we want to show the menu
          this.ui.topicContextDropdownMenu.addClass("hidden");
          this.trigger("open:topic:context:menu");
        }
      },
      "click #changeTopicStatus": function () {
        //use event instead of trigger to avoid blocking the propagation of this event
        //if we are opening the change status menu, trigger the event and generate menu listing
        if (!this.ui.topicStatusDropdown.hasClass("open")) {
          //since the menu will show up even if we don't want it to, hide it until we are sure we want to show the menu
          this.ui.topicStatusDropdownMenu.addClass("hidden");
          this.trigger("open:topic:status:menu");
        }
      },
    },
    modelEvents: {
      "change:exceededLimit": "render",
    },
    clearError: function () {
      this.ui.controlsError.html("");
    },
    controlsError: function (errorMessage) {
      this.ui.controlsError
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    nameError: function (errorMessage) {
      this.ui.topicFolderText
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    setStatusTransitionMenu: function (transitions, topics) {
      this.ui.topicStatusDropdownMenu.html("");
      transitions.forEach((transition) =>
        this._addDropdownMenuItem(
          this.ui.topicStatusDropdown,
          this.ui.topicStatusDropdownMenu,
          transition.targetStatusId,
          $.t(transition.transitionName),
          () => this.trigger("change:topic:status", topics, transition.targetStatusId),
        ),
      );
      //finally, show the menu now that we have items to show
      this.ui.topicStatusDropdownMenu.removeClass("hidden");
    },
    setTopicContextMenu: function (contexts, topics) {
      this.ui.topicContextDropdownMenu.html("");
      contexts.forEach((context) =>
        this._addDropdownMenuItem(
          this.ui.topicContextDropdown,
          this.ui.topicContextDropdownMenu,
          context.get("id"),
          context.get("status"),
          () => this.trigger("change:topic:context", topics, context.get("id")),
        ),
      );
      //finally, show the menu now that we have items to show
      this.ui.topicContextDropdownMenu.removeClass("hidden");
    },
    textboxes: {
      "#topicFolderText": {
        enableSelector: "#topicFolderText",
        modelAttribute: "name",
        placeholder: "topics.controls.folderPlaceholder",
        textArea: false,
      },
    },
    triggers: {
      "click #deleteTopics": "delete:topics",
      "click #moveTopics": "move:topics",
      "click #archiveTopics": "archive:topics",
      "click #restoreTopics": "restore:topics",
      "click #addFolder": "add:folder",
      "click #moveFolder": "move:folder",
      "click #deleteFolder": "delete:folder",
    },
    ui: {
      controlsError: "#controlsError",
      topicContextDropdown: ".topic-context-dropdown",
      topicContextDropdownMenu: ".topic-context-dropdown-menu",
      topicStatusDropdown: ".topic-status-dropdown",
      topicStatusDropdownMenu: ".topic-status-dropdown-menu",
      topicFolderText: "#topicFolderText",
    },
    _addDropdownMenuItem: function (dropdownEl, dropdownMenuEl, id, text, callback) {
      const htmlItem = this._buildDropdownMenuItem(id, text);
      dropdownMenuEl.append(htmlItem);
      dropdownMenuEl.find(`#${id}`).one("click", () => {
        //close menu
        dropdownEl.removeClass("open");
        callback.call(this);
        return false;
      });
    },
    _buildDropdownMenuItem: function (id, text) {
      return `<li id="${id}"><a>${text}</a></li>`;
    },
  });

  return TopicsControlsView;
});
